import { execOnLoad } from '@general/helpers';
import './desktop-menu.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDesktopMenu = (context) => {
  const snippetContainer = context.classList.contains(
    '.desktop-menu__container',
  )
    ? context
    : context.closest('.desktop-menu__container');
  if (!snippetContainer) return;

  const firstLevels = [
    ...snippetContainer.querySelectorAll('.desktop-menu__first-level-link'),
  ];
  firstLevels.forEach((firstLevel) => {
    const wrapper = firstLevel.querySelector(':scope > span, :scope > a');
    const text = firstLevel.querySelector(
      ':scope > a > span, :scope > span > span',
    );
    const dropdown = firstLevel.querySelector('.desktop-menu__dropdown');
    const searchBackgroundContainer = document.querySelector(
      '.header__background',
    );
    const searchMainInput =
      searchBackgroundContainer.querySelector('input[name="q"]');
    if (!wrapper || !text) return;

    wrapper.addEventListener('click', () => {
      if (
        firstLevel.classList.contains('open') ||
        firstLevels.some((el) => el.classList.contains('open')) ||
        !dropdown
      )
        return;
      firstLevel.classList.add('open');
    });
    text.addEventListener('click', () => {
      if (firstLevel.classList.contains('open')) return;
      firstLevels.forEach((el) => el.classList.remove('open'));
      if (!dropdown) return;

      if (
        searchBackgroundContainer &&
        searchMainInput &&
        searchBackgroundContainer.dataset.searchOpen == 'true'
      ) {
        searchBackgroundContainer.dataset.searchOpen = 'false';
        searchMainInput.value = '';
        searchMainInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      firstLevel.classList.add('open');
    });
  });

  const closeButtons = snippetContainer.querySelectorAll(
    '.desktop-menu__close',
  );
  if (closeButtons) {
    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        firstLevels.forEach((dropdown) => dropdown.classList.remove('open'));
      });
    });
  }

  const backdrop = snippetContainer.querySelector('.desktop-menu__layer');
  if (backdrop) {
    backdrop.addEventListener('click', () => {
      firstLevels.forEach((dropdown) => dropdown.classList.remove('open'));
    });
  }
};

execOnLoad(window.dAgency.initDesktopMenu, '.desktop-menu__container');
